import React, {Component} from "react";

import {BannerHeader} from "../structure";
import {Footer} from './../common/common';

import bgImg from "../../resources/images/bg-register.jpg"

class TermsOfUse extends Component{

	componentDidMount() {
		document.getElementById("content").scrollTo(0, 0);
	}

	render(){
		return(
			<article className="festenInfoPage">
				<BannerHeader bgImage={bgImg}>
					<h1>Brugsbetingelser & datapolitik</h1>
				</BannerHeader>
				<div className="maxWidth">

					<section className="infoSection">
						<h1>Samtykke &amp; registrering</h1>
						<p>
							N&aring;r du opretter din profil p&aring; Festen.dk, om det er i forbindelse med k&oslash;b eller
							planl&aelig;gning af fest, giver du samtykke til, at vi registrerer de oplysninger, som du selv indtaster i
							din fest og profil.
						</p>
						<p>
							&Oslash;nsker du at tilbagekalde dette samtykke, skal du kontakte Festen.dk ApS på <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a>.
						</p>
						<p>
							Oplysninger om din fest, herunder g&aelig;ster, behandles efter reglerne om personf&oslash;lsomme
							oplysninger, og vi behandler dine data efter reglerne i personoplysningsloven.
						</p>
						<p>
							Beder du om at f&aring; slettet dine fest data sletter vi dette inden for 48 timer.
						</p>
						<p>
							Vi benytter cookies p&aring; www.festen.dk. Cookies er en tekstfil, der sendes til din browser fra en
							web-server og lagres p&aring; din computers harddisk. Du kan s&aelig;tte din browser til at informere dig,
							n&aring;r du modtager en cookie. Der lagres ikke personf&oslash;lsomme oplysninger i vores cookie.
						</p>
						<p>
							Som bruger af festplanl&aelig;ggeren har du altid ret til at g&oslash;re indsigelse mod registreringen, og du
							har ret til indsigt i hvilke oplysninger, vi har registreret om dig. Du har ogs&aring; ret til at
							f&aring; en kopi af dine data. Denne kopi kan du hente ved at sende en mail til <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a>.
						</p>
						<p>	
							Hvis din profil er inaktiv i 1 &aring;r,
							s&aring; sletter vi den og alle tilh&oslash;rende data. Ved inaktiv forst&aring;s en gratis profil, der ikke
							har v&aelig;ret logget ind.
						</p>
						<p>
							Ved oprettelsen giver du samtykke til, at du modtager e-mail og push notifikationer fra os, n&aring;r der er
							nyt p&aring; din profil. Hvis ikke du &oslash;nsker at modtage disse, s&aring; kan du frav&aelig;lge dette
							ved at sende en mail til <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a>.
						</p>
						<p>
							Du kan ligeledes modtage emails og notifikationer med tilbud og nyheder fra os. Hvis ikke du &oslash;nsker at
							modtage disse, s&aring; kan du frav&aelig;lge dette ved at sende en mail til <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a>.
						</p>

						<h2>Datasikkerhed</h2>
						<p>
							Alle servere, som benyttes til lagring af vores kunders data, er placeret i et krypteret og distribueret
							servernetv&aelig;rk leveret af Powerhosting. Al data bliver dagligt sikkerhedskopieret og lagt
							p&aring; flere backupservere i krypteret form, som kun er tilg&aelig;ngeligt for Powerhosting samt Festen.dk
							administratorer.
						</p>
					</section>

					<section className="infoSection">
						<h1>Persondata</h1>
						<p>
							Ved oprettelse af en fest og profil p&aring; <a href="http://www.festen.dk">www.festen.dk</a>, accepterer du,
							at Festen.dk ApS behandler nedest&aring;ende personoplysninger om dig. Det er en betingelse for at have en
							profil p&aring; Festen.dk, at du giver dette samtykke.
						</p>

						<h2>Behandling af personoplysninger &ndash; opfyldelse af kontrakt</h2>
						<p>
							I forbindelse med k&oslash;b p&aring; <a href="http://www.festen.dk">www.festen.dk</a> (se kontaktoplysninger nedenfor) har du indtastet
							en r&aelig;kke personoplysninger, herunder s&aelig;rligt
						</p>
						<p>
							-Dit navn<br />
							-Din adresse/arbejdsadresse<br />
							-Din e-mailadresse<br />
							-Dit telefonnummer<br />
							-Dine betalingsoplysninger<br />
						</p>
						<p>
							Disse personoplysninger behandler vi i forbindelse med ekspederingen af dit k&oslash;b, da det er
							n&oslash;dvendigt for, at vi kan opfylde vores del af handlen &ndash; det vil sige sende dig
							produkterne.
						</p>
						<p>
							Oplysningerne om dit navn, adresse, telefonnummer og e-mailadresse blive udleveret til de
							p&aring;g&aelig;ldende forhandlere samt logistikvirksomheder med henblik p&aring; levering af fysiske
							produkter.
						</p>

						<h2>Typer af personoplysninger og form&aring;l</h2>
						<h2>Festen.dk profiler</h2>
						<p>
							I forbindelse med oprettelse af en profil, om det til planl&aelig;gning af fest eller k&oslash;b, og brug af
							festens planl&aelig;gningsv&aelig;rkt&oslash;j p&aring; <a href="http://www.festen.dk">www.festen.dk</a>,
							vil Festen.dk ApS anmode om at behandle og opbevare f&oslash;lgende oplysninger:
						</p>
						<p>
							-Din e-mail<br />
							-Dit navn
						</p>
						<p>
							Herudover har du selv mulighed for at udfylde f&oslash;lgende personoplysninger, som vil blive behandlet af
							Festen.dk ApS:
						</p>
						<p>
							-Telefonnummer<br />
							-Adresse<br />
							-De oplysninger du skriver, n&aring;r du opretter indhold via festplanl&aelig;ggeren
						</p>
						<h2>Generelt om typer og form&aring;l</h2>
						<p>
							Form&aring;let med behandling af ovenst&aring;ende personoplysninger er at oprette din profil samt
							administrere festplanl&aelig;ggeren.
						</p>
						<p>
							Indhold som aktivt i festplanl&aelig;ggeren tilknyttes en festhjemmeside, kan dog tilg&aring;es af
							tredjepart.
						</p>

						<h2>COOKIES og pixel tags</h2>
						<p>
							Festen.dk ApS indsamler oplysninger, som kan omfatte personoplysninger, fra din browser, n&aring;r du bruger
							vores App. Vi bruger en r&aelig;kke metoder, som pixel tags, til at indsamle oplysningerne, som kan omfatte
							(1) ip-adresse, (2) personlig, og oplysninger om, hvorvidt din enhed har software, som kan tilg&aring; visse
							funktioner, (3) personlig enhedsidentifikator og enhedstype, (4) dom&aelig;ne og sprog, (5) operativsystem
							og systemindstillinger, (6) land og tidszone, (7) oplysninger om din interaktion med vores App, som fx
							klikadf&aelig;rd, k&oslash;b og valgte indstillinger, samt (9) adgangstidspunkt og
							reference-URL&rsquo;er.
						</p>
						<p>
							Vi bruger pixel tags til at
							f&oslash;lge vores kunders brug af vores festplanl&aelig;gger samt hjemmeside og til at forst&aring; vores
							kunders indstillinger (som fx omr&aring;devalg). Dette giver os mulighed for at levere ydelser til vores
							kunder og forbedre deres brugeroplevelse. Vi bruger pixel tags til at indhente generelle oplysninger om
							websitetrafik og websiteinteraktion og til at identificere tendenser og indsamle statistikker, s&aring; vi
							kan forbedre www.festen.dk.
						</p>
						<a href="https://www.festen.dk/privacy-policy-cookie-restriction-mode">
							Læs mere her
						</a>
					</section>

					<section className="infoSection">
						<h1>Datasikkerhed</h1>
						<p>
							Vi behandler dine personoplysninger sikkert og fortroligt i overensstemmelse med g&aelig;ldende lovgivning,
							herunder persondataforordningen og databeskyttelsesloven.
						</p>
						<p>
							Dine oplysninger vil alene blive anvendt til det form&aring;l, de er indsamlet til, og vil blive slettet,
							n&aring;r dette form&aring;l er opfyldt eller ikke l&aelig;ngere relevant.
						</p>
						<p>
							Vi anvender tredjeparter til behandling af dine betalingsoplysninger og til h&aring;ndtering af dine
							k&oslash;b. Vi har indg&aring;et databehandleraftaler med disse databehandlere, hvilket er vores garanti
							for, at de overholder g&aelig;ldende regler om beskyttelse af dine personoplysninger.
						</p>

						<h2>Oplysning, indsigelse, &aelig;ndring, dataportabilitet og sletning</h2>
						<p>
							Du kan altid kontakte os for at f&aring; oplyst, hvilke af dine personoplysninger vi ligger inde med.
						</p>
						<p>
							Dette kan ske ved henvendelse til:
						</p>
						<p>
							Thomas Eriksson<br />
							Festen.dk ApS<br />
							CVR-nr. 34725195<br />
							Sdr. Boulevard 42, kld. tv.,<br />
							5000 Odense C<br />
							E-mail: <a href="mailto:thomas@festen.dk">thomas@festen.dk</a>
						</p>
						<p>
							Hvis der er fejl i vores oplysninger, har du krav p&aring; at f&aring; dem rettet, s&aring; vi har de
							rigtige, lige som du har ret til at f&aring; udleveret oplysningerne i et almindeligt format
							(dataportabilitet). &Oslash;nsker du at udnytte din ret til &aelig;ndring eller dataportabilitet, er du
							ogs&aring; meget velkommen til at skrive til os p&aring; ovenn&aelig;vnte e-mailadresse.
						</p>
						<p>
							&Oslash;nsker du ikke l&aelig;ngere, at vi skal behandle dine personoplysninger, eller at vi skal
							begr&aelig;nse behandlingen af dine personoplysninger, kan du ogs&aring; sende os en anmodning herom til
							ovenn&aelig;vnte e-mailadresse.
						</p>
						<p>
							Dine oplysninger (undtagen din e-mailadresse, hvis du har givet samtykke til behandling heraf med henblik
							p&aring; modtagelse af tilbud) vil blive slettet efter 5 &aring;r efter dit k&oslash;b, da vi er forpligtet
							til at gemme oplysningerne i 5 &aring;r i medf&oslash;r af bogf&oslash;ringsloven.
						</p>
						<p>
							Hvis du &oslash;nsker at klage over Festen.dk ApS&rsquo; behandling af dine personoplysninger, kan dette ske
							til Datatilsynet, p&aring; adressen
						</p>
						<p>
							Borgergade 28,5.,<br />
							1300 K&oslash;benhavn,<br />
							telefon 33 19 32 00<br />
							e-mail: dt@datatilsynet.dk.
						</p>
					</section>

					<section className="infoSection">
						<h1>Betingelser for kommunikation</h1>
						<h2>Samtykke af kommunikation</h2>
						<p>
							Ved oprettelse af festprofil eller tilmelding til nyhedsbrev p&aring; festen.dk, acceptere du at modtage
							kommunikation i form af emails fra Festen.dk ApS. Dette er en betingelse for oprettelse af en festprofil
							p&aring; <a href="http://www.festen.dk">www.festen.dk</a>, at du giver samtykke til dette.
						</p>

						<h2>Afsender</h2>
						<p>
							Festen.dk ApS er afsender af al kommunikation du modtager, som tilknyttes en festen profil.
						</p>
						<p>
							Festen.dk ApS <br/>
							CVR-nr. 34725195 <br/>
							Sdr. Boulevard 42, kld. tv.,<br/> 
							5000 Odense C <br/>
							e-mail <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a>
						</p>

						<h2>Kontaktoplysninger</h2>
						<p>
							Dine kontaktoplysninger (e-mailadresse) opbevares og benyttes udelukkende af Festen.dk ApS.
							Kontaktoplysninger deles ikke med tredjepart. Dine kontakt- og personoplysninger, behandles jf.
							Festen.dk ApS&acute; betingelser om persondata.En aktiveret og valid e-mailadresse er kr&aelig;vet for
							kommunikation,
							samt oprettelse af en Festen.dk profil. Det er profilejers ansvar, at vedligeholde en fungerende
							e-mailadresse,
							til kommunikation med Festen.dk ApS. En e-mailadresse anses som ikke-fungerende, n&aring;r afsendelse til
							e-mailadressen
							er mislykkedes minimum 5 gange, inden for en periode p&aring; 90 dage. Profiler der ikke vedligeholder en
							fungerende
							e-mailadresse, deaktiveres, og slettes efter yderligere en periode p&aring; 90 dage.
						</p>
					</section>
				</div>
				<Footer/>
			</article>
		)
	}
};

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/components/infoPages/termsofuse.js